var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackflowReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 0.615234V4.35062",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.615356 15.3844V7.37828C0.615356 5.70443 1.9692 4.35059 3.63689 4.35059H12.3507C14.0246 4.35059 15.3784 5.71059 15.3784 7.37828V15.3844",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62459 0.615234H10.3754",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 15.1996V10.821C10.4 10.1527 10.0464 9.59961 9.60827 9.59961H6.39167C5.95848 9.59961 5.59997 10.145 5.59997 10.821V15.1996",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackflowReport);
export default __webpack_public_path__ + "static/media/backflow-report.7559f14f2dbf5b9fac6f056a444618b8.svg";
export { ForwardRef as ReactComponent };